import React from 'react';

const Tag = ({ status }) => {
    const tagClass = status === 'claimed' ? 'bg-success' : 'bg-danger';
    const tagText = status === 'claimed' ? 'Claimed' : 'Unclaimed';

    const wrapperStyle = {
        textAlign: 'left',  // Ensure the tag is aligned to the left
        paddingLeft: '5px', // Add some padding to control the sizing/spacing
    };

    return (
        <div style={wrapperStyle}>
            <span className={`badge ${tagClass}`}>{tagText}</span>
        </div>
    );
}

export default Tag;
